import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DocumentCalculationMethodEnum } from '@zaoblako/shared/modules/document/enums/document.calculation.method.enum';

/**
 * Localised human-readable names for {@link DocumentCalculationMethodEnum} enumeration values
 */
export const DocumentCalculationMethodEnumI18n: Record<I18nLocalesEnum, Record<DocumentCalculationMethodEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [DocumentCalculationMethodEnum.SALE]: 'Начисления',
    [DocumentCalculationMethodEnum.KASS]: 'Кассовый',
  },
  [I18nLocalesEnum.EN_US]: {
    [DocumentCalculationMethodEnum.SALE]: 'Sale',
    [DocumentCalculationMethodEnum.KASS]: 'Cash',
  },
};
